module.exports = __webpack_public_path__ + "img/1507910582.85792ec5.jpg";